import styled from 'styled-components'

export const DictionaryLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
`

export const VehiclesToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 12px;
`

export const ToolbarFilters = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`

export const ToolbarActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
`

export const VehiclesTableWrapper = styled.div`
  .ant-table {
    font-size: 12px;
  }

  .ant-table-row {
    cursor: pointer;
  }
`

export const SelectWithAction = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 32px;
  gap: 8px;
  width: 100%;
`
